import { FC } from "react"

const AlertWrapper: FC = () => {
    return (
        <>
            You haven't any notification... 
        </>
    )
}
export { AlertWrapper }